/** Seta do design. Usa currentColor para seguir o token de quem a renderiza. */
export function ArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M2.4996 6H9.5004M6 9.5004L9.5004 6L6 2.4996"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ArrowIcon;
